// src/components/StructuredData.js
import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "SVR Taxi",
    "image": "https://svrtaxi.netlify.app/logo.png",
    "@id": "https://svrtaxi.netlify.app",
    "url": "https://svrtaxi.netlify.app",
    "telephone": "+91 9965821750",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "3/82 , ERIKKADAI , VEERAPANDI,Periyaseeragapadi",
      "addressLocality": "Salem",
      "addressRegion": "TN",
      "postalCode": "636308",
      "addressCountry": "IN"
    },
    "sameAs": [
      "https://www.facebook.com/svrtaxi",
      "https://www.instagram.com/svrtaxi"
    ],
    "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
    "priceRange": "$8 - $10",
    "servesCuisine": "Taxi & Cab Service",
    "description": "SVR Taxi & Cabs in Salem - Safe Drive is the best platform for car hire in Salem. We provide dedicated and on-demand car rental services in Salem.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91 9965821750",
      "contactType": "Customer Service"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
